module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-animate/~/babel-runtime/core-js/object/define-property.js
 ** module id = 1325
 ** module chunks = 3
 **/